import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { CountriesActivites } from '../../interface/Back';
import { useAppDispatch, useAppSelector } from '../../Hooks';
import { createActivity, getAllCountries } from '../../redux/Actions';
import { FormCreate, FormErrors } from '../../types';
import { EvenChanges, EvenSubmit, EvenSelect, EvenDelete } from '../../types/Functions';
import { FormCreated } from './FormCreated';
import { validation } from './Validation';

export const CreateActivity = () => {
  const formState: FormCreate = {
    name: "",
    difficulty: 0,
    duration: "",
    season: "",
    country: [],
  }

  const formErrors: FormErrors = {
    name: "",
    difficulty: "",
    duration: "",
    season: "",
    country: [],
  }
  
  const [activity, setActivity] = useState<FormCreate>(formState);

  const [errors, setErrors] = useState<FormErrors>(formErrors);
  const dispatch = useAppDispatch();
  const history = useHistory();

  useEffect(() => {
    dispatch<any>(getAllCountries());
  }, [dispatch]);

  const handlerChange: EvenChanges = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    setActivity({
      ...activity,
      [e.target.name]: e.target.value,
    });
    setErrors(
      validation({
        ...activity,
        [e.target.name]: e.target.value,
      })
    );
  };

  const handlerSubmit: EvenSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (
      activity.name &&
      activity.difficulty &&
      activity.duration &&
      activity.season &&
      activity.country.length >= 1
    ) {
      dispatch<any>(createActivity(activity));
      alert("Has creado una nueva Actividad!🤩");
      //* Seteo TODO desde CERO
      setActivity(formState);
      history.push("/home");
    } else {
      alert("No puedes dejar ningun campo vasío!!");
    }
  };

  let allCountries: CountriesActivites[] = useAppSelector((state) => state.countries).sort((a: CountriesActivites, b: CountriesActivites) => {
      if (a.name < b.name) return -1;
      return 0;
    }
  );
  
  let listCountries: JSX.Element[] = allCountries.map((el: CountriesActivites) => (
    <option key={el.cca3} className='option' >
      {el.name}
    </option>
  ));

  const SelectCountries: EvenSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setActivity({
      ...activity,
      country: activity.country.includes(e.target.value)
        ? activity.country
        : [...activity.country, e.target.value],
    });
    //! Se SETEA para evitar ERRORES cuando se llena campos NO OBLIGATORIOS
    setErrors(
      validation({
        ...activity,
        [e.target.name]: e.target.value,
      })
    );
  };

  const DeleteCountries: EvenDelete = (ele: string) => {
    setActivity({
      ...activity,
      country: activity.country.filter((el: string) => el !== ele),
    });
  }

  return (
    <FormCreated
      activity={activity}
      errors={errors}
      handlerChange={handlerChange}
      handlerSubmit={handlerSubmit}
      listCountries={listCountries}
      SelectCountries={SelectCountries}
      DeleteCountries={DeleteCountries}
    />
  )
}
